import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { FormHelperText, InputLabel } from '@material-ui/core';
import { InputText, SecondaryButton, DatePicker, SingleSelect } from '../../../../../Core/Controls';
import { useToast } from '../../../../../Core/Hooks/useToast';

import moment from 'moment';
import { ContractSetOnsiteDate, ContractsStepper_DropDown } from '../../../../../Core/Services/InternalUser/InternalDashService';

const ContractSetOnsiteDateModal = (props) => {
    const [state, setState] = useState({
        errors: {},
        contractServiceAreaID: null,
        contractEngineerUserID: null,
        contractOnsiteDate: moment().format('YYYY-MM-DD')
    });
    const [btnLoader, setBtnLoader] = useState(false);
    const { showToastSuccess, showToastError } = useToast();

    useEffect(async () => {
        let res = await ContractsStepper_DropDown();
        setState((st) => ({
            ...st,
            serviceAgents: res.data.serviceAgents || [],
            technicians: res.data.technicians || []
        }));
    }, []);

    const onFieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const singleSelectChange = (nm) => (ev, val) => {
        setState((st) => ({ ...st, [nm]: val }));
    };

    const validations = () => {
        const { contractOnsiteDate, contractServiceAreaID, contractEngineerUserID } = state;
        let formIsValid = true;
        let errors = {};
        if (!contractOnsiteDate) {
            errors.contractOnsiteDate = 'Date is required';
            formIsValid = false;
        }
        // if (!contractServiceAreaID?.id) {
        //     errors.contractServiceAreaID = 'Service area is required';
        //     formIsValid = false;
        // }
        // if (!contractEngineerUserID?.id) {
        //     errors.contractEngineerUserID = 'Engineer is required';
        //     formIsValid = false;
        // }
        setState((st) => ({ ...st, errors: errors }));
        return formIsValid;
    };

    const SubmitHandler = async () => {
        if (validations()) {
            setBtnLoader(true);
            let failedResponses = 0;
            const totalVehicles = props.checkedVehicleList.length;

            for (let index = 0; index < totalVehicles; index++) {
                try {
                    let response = await ContractSetOnsiteDate({
                        contractVehicleID: props.checkedVehicleList[index].contractVehicleID,
                        vehicleContractID: props.checkedVehicleList[index].vehicleContractID,
                        contractOnsiteDate: state.contractOnsiteDate
                        // contractServiceAreaID: state.contractServiceAreaID?.id || null,
                        // contractEngineerUserID: state.contractEngineerUserID?.id || null
                    });

                    // Display the counter n of n for each vehicle
                    showToastSuccess(`Vehicle ${index + 1} of ${totalVehicles}: ${response.success ? 'Success' : 'Failed'}`);

                    if (!response.success) {
                        failedResponses += 1;
                    }
                } catch (error) {
                    // Handle the error for the specific vehicle
                    showToastError(`An error occurred for vehicle ${index + 1}: ${error.message}`);
                    failedResponses += 1;
                }
            }

            // Final success or failure message after all API calls
            if (failedResponses === 0) {
                showToastSuccess('Vehicle onsite details saved successfully.');
                props.onClose(true);
            } else {
                showToastError(`${failedResponses} vehicle(s) failed.`);
            }

            setBtnLoader(false);
        }
    };

    // const SubmitHandler = async () => {
    //     if (validations()) {
    //         setBtnLoader(true);
    //         let promises = props.checkedVehicleList.map((q) => {
    //             return ContractSetOnsiteDate({
    //                 contractVehicleID: q,
    //                 contractOnsiteDate: state.contractOnsiteDate
    //                 // contractServiceAreaID: state.contractServiceAreaID?.id || null,
    //                 // contractEngineerUserID: state.contractEngineerUserID?.id || null
    //             });
    //         });

    //         try {
    //             let responses = await Promise.all(promises);

    //             // Check if all responses are successful
    //             let allSuccessful = responses.every((response) => response.success);

    //             if (allSuccessful) {
    //                 showToastSuccess('Vehicle delivery details saved successfully.');
    //                 props.onClose(true);
    //             } else {
    //                 // Find out which responses failed
    //                 let failedResponses = responses.filter((response) => !response.success);
    //                 showToastError(`Error: ${failedResponses.length} items failed.`);
    //             }
    //         } catch (error) {
    //             // Handle any other errors that may occur
    //             showToastError(`An error occurred: ${error.message}`);
    //         }
    //         setBtnLoader(false);
    //     }
    // };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} className="mandatory-fields">
                <InputLabel shrink>Onsite Date</InputLabel>
                <DatePicker name="contractOnsiteDate" placeholder="Onsite Date" value={state.contractOnsiteDate || ''} onChange={onFieldChange} />
                <FormHelperText error>{state.errors.contractOnsiteDate}</FormHelperText>
            </Grid>
            {/* <Grid item xs={12} className="mandatory-fields">
                <InputLabel shrink>Service Area</InputLabel>
                <SingleSelect options={state.serviceAgents} value={state.contractServiceAreaID} onChange={singleSelectChange('contractServiceAreaID')} />
                <FormHelperText error>{state.errors.contractServiceAreaID}</FormHelperText>
            </Grid>
            <Grid item xs={12} className="mandatory-fields">
                <InputLabel shrink>Engineer</InputLabel>
                <SingleSelect options={state.technicians} value={state.contractEngineerUserID} onChange={singleSelectChange('contractEngineerUserID')} />
                <FormHelperText error>{state.errors.contractEngineerUserID}</FormHelperText>
            </Grid> */}

            <Grid item xs={12}>
                <SecondaryButton fullWidth isBtnLoader={btnLoader} className="submit_btn" onClick={SubmitHandler}>
                    Submit
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default ContractSetOnsiteDateModal;
